import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const AdminRolesListHeader = ({
  orderBy,
  order,
  handleChangeOrder,
}) => {
  const intl = useIntl();

  const changeOrder = (e, field) => {
    e.preventDefault();
    handleChangeOrder(field, order === 'asc' ? 'desc' : 'asc');
  };

  return (
    <tr>
      <th className={`th-sortable${orderBy === 'name' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { changeOrder(e, 'name'); }}>
          {intl.formatMessage({ defaultMessage: 'Name' })}
          {' '}
          {orderBy === 'name' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th className={`th-sortable${orderBy === 'description' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { changeOrder(e, 'description'); }}>
          {intl.formatMessage({ defaultMessage: 'Description' })}
          {' '}
          {orderBy === 'description' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Users' })}
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

AdminRolesListHeader.propTypes = {
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
};

export default AdminRolesListHeader;
